import { Workspace } from "@/components/graphql/schema.graphql";

type SorterWorkspace = Pick<Workspace, "name" | "planTier">;
type SorterMembership = {
  workspace?: SorterWorkspace;
};

const planTierOrder = ["PRO", "STUDIO", "ENTERPRISE"];

export const workspacePlanTierSorter = (
  a?: SorterWorkspace,
  b?: SorterWorkspace,
) => {
  if (!a?.planTier || !b?.planTier) {
    return 0;
  }
  if (a.planTier === b.planTier && a.name === b.name) {
    return 0;
  }
  const diff =
    planTierOrder.indexOf(b.planTier) - planTierOrder.indexOf(a.planTier);
  if (diff !== 0) {
    return diff;
  }
  return a.name.localeCompare(b.name);
};

export const membershipPlanTierSorter = (
  a: SorterMembership,
  b: SorterMembership,
) => {
  return workspacePlanTierSorter(a.workspace, b.workspace);
};
